// list of i18n keys that are defined outside of the ads-copilot project but need to be included in copilot-i18n
export const additionalI18nKeys = [
  _TL_('Generating insights...'),
  _TL_('We are unable to display the graph at this time. Please try again later.'),
  _TL_('Conv.'),
  _TL_('Impr.'),
  _TL_('Clicks'),
];
